import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, LabelList, Cell } from "recharts";

export default ({ data }) => {
  return (
    <div className="chart-container">
      <ResponsiveContainer>
        <BarChart data={data}>
          <XAxis dataKey="campus_name" />
          <YAxis/>
          <CartesianGrid strokeDasharray="3 3"/>
          <Tooltip />
          <Bar name="Reuniões" dataKey="count_campus">
            {data.map((entry, index) => {
              let color = ''

              if (/chapecó/i.exec(entry.campus_name) !== null) {
                color = "#9cc177";
              }
              else if (/passo/i.exec(entry.campus_name) !== null) {
                color = "#f9d45c"; 
              }
              else if (/laranjeira/i.exec(entry.campus_name) !== null) {
                color = "#509ee3"; 
              }
              else if (/cerro/i.exec(entry.campus_name) !== null) {
                color = "#509ee3"; 
              }
              else if (/realeza/i.exec(entry.campus_name) !== null) {
                color = "#F1B556"; 
              }
              else if (/erechim/i.exec(entry.campus_name) !== null) {
                color = "#a989c5"; 
              }
              else if (/reitoria/i.exec(entry.campus_name) !== null) {
                color = "#A6E7F3"; 
              }

              return (
                <Cell key={`cell-${index}`} fill={color} />
              )
            })}
          </Bar>
        </BarChart>
      </ResponsiveContainer>

      <style jsx>{`
        .chart-container {
          width: 100%;
          height: 400px;
        }
      `}</style>
    </div>
  );
}



// WEBPACK FOOTER //
// components/stats/PerCampusStats.js